export default __webpack_public_path__ + "static/media/TextileIcon.b19494c1.png";